import uuid from 'utils/uuid';
import {
  SUCCESS_TYPE, ERROR_TYPE, TEMPLATE_CREATION, TEMPLATE_UPDATE,
} from 'utils/toastDispacher';
import { toastDispacher } from 'utils';
import { getTexts } from '@twnel/web-components';
import { botspecsActions } from '../reducer';
import { postBotspec } from './chatbots';
import logger from 'utils/logger';

export const { updateStateTemplates } = botspecsActions;

export const testApi = (body) => async (dispatch, getState, getContext) => {
  try {
    const { api } = getContext();
    const post = api.templates.test;
    const response = await post(body);
    return response;
  } catch (error) {
    logger.error(error);
    return error;
  }
};

export const searchTemplates = (query) => async (dispatch, getState, getContext) => {
  try {
    const { api } = getContext();
    const get = api.templates.getByQuery;
    let queryRequest = '?';
    Object.keys(query).forEach((key) => {
      queryRequest += `${key}=${query[key]}&`;
    });
    const templates = await get(queryRequest);
    dispatch(updateStateTemplates(templates));
  } catch (error) {
    logger.error(error);
  }
};

export const generateTemplate = (body) => async (dispatch, getState, getContext) => {
  const texts = getTexts(getState());
  try {
    const {
      template, name, description, category, isPublic,
    } = body;
    const { api } = getContext();
    const id = uuid();
    const { company } = template;
    dispatch(postBotspec(
      {
        ...template,
        rete_json: {
          ...template.rete_json,
          template: {
            id,
            name,
            description,
            category,
            isPublic,
            published: false,
          },
        },
      },
    ));
    delete template.company;
    const duplicatedBotspec = {
      ...template,
      id,
      originalIdBot: template.id,
      originalCompany: company,
      name,
      description,
      category,
      isPublic,
      published: false,
      rete_json: {
        ...template.rete_json,
        id: `${id}@1.0.0`,
        name,
      },
    };
    const { create } = api.templates;
    await create(duplicatedBotspec);
    toastDispacher({
      actionId: TEMPLATE_CREATION,
      texts,
      type: SUCCESS_TYPE,
    });
  } catch (error) {
    logger.error(error);
    toastDispacher({
      actionId: TEMPLATE_CREATION,
      texts,
      type: ERROR_TYPE,
    });
  }
};

export const updateTemplate = (body) => async (dispatch, getState, getContext) => {
  const texts = getTexts(getState());
  try {
    const {
      template, name, description, category, isPublic,
    } = body;
    const { api } = getContext();
    const { id } = template.rete_json.template;
    dispatch(postBotspec(
      {
        ...template,
        rete_json: {
          ...template.rete_json,
          template: {
            ...template.rete_json.template,
            name,
            description,
            category,
            isPublic,
          },
        },
      },
    ));
    const { update, getById } = api.templates;
    const templateToUpdate = await getById(id);
    const duplicatedBotspec = {
      ...templateToUpdate,
      name,
      description,
      category,
      isPublic,
      rete_json: {
        id: templateToUpdate.rete_json.id,
        name,
        ...template.rete_json,
      },
      spec_json: {
        ...template.spec_json,
      },
    };
    delete duplicatedBotspec._id;
    await update(duplicatedBotspec);
    toastDispacher({
      actionId: TEMPLATE_UPDATE,
      texts,
      type: SUCCESS_TYPE,
    });
  } catch (error) {
    logger.error(error);
    toastDispacher({
      actionId: TEMPLATE_UPDATE,
      texts,
      type: ERROR_TYPE,
    });
  }
};

export const publishTemplate = (botspec) => async (dispatch, getState, getContext) => {
  const texts = getTexts(getState());
  try {
    const { api } = getContext();
    const { update, getById } = api.templates;
    dispatch(postBotspec(
      {
        ...botspec,
        rete_json: {
          ...botspec.rete_json,
          template: {
            ...botspec.rete_json.template,
            published: true,
          },
        },
      },
    ));
    const { id } = botspec.rete_json.template;
    const templateToUpdate = await getById(id);
    const duplicatedBotspec = {
      ...templateToUpdate,
      published: true,
    };
    delete duplicatedBotspec._id;
    await update(duplicatedBotspec);
    toastDispacher({
      actionId: TEMPLATE_UPDATE,
      texts,
      type: SUCCESS_TYPE,
    });
  } catch (error) {
    logger.error(error);
    toastDispacher({
      actionId: TEMPLATE_UPDATE,
      texts,
      type: ERROR_TYPE,
    });
  }
};
